<script setup lang="ts">
import { computed } from 'vue';
import { cardProps } from 'naive-ui';
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  ...cardProps,
  /** Clickable surface: pointer cursor + hover darkens the border (mock 5a). */
  interactive: {
    type: Boolean,
    default: false,
  },
});

// `interactive` is ours, not n-card's — keep it off the DOM element.
const passThrough = computed(() => {
  const { interactive, ...rest } = props;
  return rest;
});

const borderHover = gaiaNeutral.borderHover;
</script>

<template>
  <n-card v-bind="passThrough" :class="{ 'gaia-card--interactive': props.interactive }">
    <template v-if="$slots.header" #header>
      <slot name="header" />
    </template>
    <template v-if="$slots['header-extra']" #header-extra>
      <slot name="header-extra" />
    </template>
    <slot />
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
    <template v-if="$slots.action" #action>
      <slot name="action" />
    </template>
  </n-card>
</template>

<style scoped>
/* Surface colors live in the theme (gaia-light.json Card section); only the
   hover state stays here because naive's Card exposes no hover var. The
   custom property is the single definition point and can be overridden from
   outside the component. */
.gaia-card--interactive {
  --gaia-card-border-hover: v-bind(borderHover);
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.gaia-card--interactive:hover {
  border-color: var(--gaia-card-border-hover);
}
</style>
